<app-feature-details-grid>
  <app-feature-list-container>
    <app-feature-list-item
      *ngIf="heatingDemand$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate }}"
      [value]="
        installationFeaturesStore.callForHeatHeatingZoneOperatingProgramName$ | async | translate
      "
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <ng-container feature *ngIf="heatingCurvePresets$ | async | ready as feature">
      <app-feature-list-item
        *ngIf="feature | value2: featurePropertyKey.active"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PRESETS.TITLE' | translate }}"
        [value]="feature.properties?.value?.value | translateHeatingCurvePresets"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
    </ng-container>
    <app-feature-list-item
      *ngIf="heatingConfigurationRegulation$ | async | ready as feature"
      label="{{
        '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.CONFIGURATION_REGULATION.TITLE' | translate
      }}"
      [value]="feature.properties?.mode?.value | translateHeatingConfigurationRegulation"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="heatingSensorsTemperature$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.FLOW_TEMPERATURE.TITLE' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>

<ng-container *ngIf="heatingCurve$ | async | ready">
  <div class="divider"></div>
  <h2>
    {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.HEATING_CURVE.TITLE' | translate }}
  </h2>

  <app-feature-details-grid>
    <app-heating-zone-heat-curve-panel></app-heating-zone-heat-curve-panel>
  </app-feature-details-grid>
</ng-container>
